export default __webpack_public_path__ + "static/hero1-2c0445cae86f4243433a2f5a22b2c031.svg";